/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ChangePasswordQueryVariables = {};
export type ChangePasswordQueryResponse = {
    readonly configuration: {
        readonly passwordValidationRegex: string | null;
        readonly passwordValidationMessage: string | null;
    } | null;
};
export type ChangePasswordQuery = {
    readonly response: ChangePasswordQueryResponse;
    readonly variables: ChangePasswordQueryVariables;
};



/*
query ChangePasswordQuery {
  configuration {
    passwordValidationRegex
    passwordValidationMessage
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "Configuration",
            "kind": "LinkedField",
            "name": "configuration",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "passwordValidationRegex",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "passwordValidationMessage",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "ChangePasswordQuery",
            "selections": (v0 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "ChangePasswordQuery",
            "selections": (v0 /*: any*/)
        },
        "params": {
            "cacheID": "5c7c96741c0bd755c0c9145c16791789",
            "id": null,
            "metadata": {},
            "name": "ChangePasswordQuery",
            "operationKind": "query",
            "text": "query ChangePasswordQuery {\n  configuration {\n    passwordValidationRegex\n    passwordValidationMessage\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '17135c62a56e558a5918d248cde75301';
export default node;
